import React from "react";

/*
    A plan's price, in the shape the Cruip design uses: a small "$" sitting on
    the baseline of a large amount, with the period trailing in muted type.

    Everything is derived from the fields the catalogue already carries
    (`unit_amount` and `recurring.interval`) rather than a second set of
    display-only fields that could drift out of step with them.

    Free is a word, not "$0" — a zero price rendered as a number reads as a
    missing value, which is exactly how the old Settings page came to show
    "$ per month" to customers on plans it could not price.
*/
const PlanPrice = ({ amount, interval }) => {
  if (amount === 0) {
    return (
      <div className="plan-tier__price">
        <span className="plan-tier__amount">Free</span>
      </div>
    );
  }

  /*
      An explicit map, not string surgery on `interval`. Abbreviating by
      slicing would turn a future "year" into "/ye"; an unrecognised interval
      is better rendered in full than mangled.
  */
  const PERIODS = { month: "/mo", year: "/yr", "one-time fee": "one-time fee" };
  const period = PERIODS[interval] || interval;

  return (
    <div className="plan-tier__price">
      <span className="plan-tier__currency">$</span>
      <span className="plan-tier__amount">{amount}</span>
      <span className="plan-tier__period">{period}</span>
    </div>
  );
};

export default PlanPrice;
